import { ReactNode } from 'react'

interface IListProps {
  listText: string[]
}

const List = (props: IListProps) => {
  return (
    <ul className='text-xs'>
      {props.listText.map((text, i, arr) => (
        <li key={i}>
          {arr.length > 1 ? '· ' : ''}
          {text}
        </li>
      ))}
    </ul>
  )
}

export const infoNodeComponents = {
  List
}

export type TInfoNodeCb = (components: typeof infoNodeComponents) => ReactNode
